import { render, staticRenderFns } from "./LargeDataScreen.vue?vue&type=template&id=b20467ae&scoped=true"
import script from "./LargeDataScreen.vue?vue&type=script&lang=js"
export * from "./LargeDataScreen.vue?vue&type=script&lang=js"
import style0 from "./LargeDataScreen.vue?vue&type=style&index=0&id=b20467ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20467ae",
  null
  
)

export default component.exports